import { render } from "./InvoiceStatus.vue?vue&type=template&id=56dda1f0&scoped=true&ts=true"
import script from "./InvoiceStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceStatus.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceStatus.vue?vue&type=style&index=0&id=56dda1f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dda1f0"],['__file',"resources/js/vue/domain/invoice/components/shared/InvoiceStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56dda1f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56dda1f0', __exports__)) {
    api.reload('56dda1f0', __exports__)
  }
  
  module.hot.accept("./InvoiceStatus.vue?vue&type=template&id=56dda1f0&scoped=true&ts=true", () => {
    api.rerender('56dda1f0', render)
  })

}


export default __exports__